import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { CoverageSVG, AlreadyRegisteredSVG } from '../../img/GlobalSVG';
import Button from '../common/button';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const AlreadyRegisteredErrorMsg = ({
  errorContent = 'The registration link is already used or has expired.',
}) => {
  const [backtoLogin, setBackToLogin] = useState(false);
  const gobacktoLoginPage = () => {
    setBackToLogin(true);
  };

  if (backtoLogin) {
    return <Navigate to="/admin" push={true}></Navigate>;
  }

  return (
    <Container className="registration-error-container text-center mt-5">
      <Row>
        <Col>
          <AlreadyRegisteredSVG.AlreadyRegisteredSVG />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="content-box">
            <div className="registration-error-title">{errorContent}</div>
            <p>
              Try logging in with the credentials that you used to register to
              access your account. Or use the password reset option on the
              <br /> login page to access your account, if you have forgotten
              your password.
            </p>
            <GenericButton
              onClick={gobacktoLoginPage}
              variant="primary"
              className="login-button d-flex mx-auto text-center "
            >
              LOGIN
            </GenericButton>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="did-you-know-container-box d-flex">
            <CoverageSVG.BulbSVG />
            <div className="content-box text-left">
              <h4>Did you know?</h4>
              <p>
                If you are physically tired, the best thing to do is exercise as
                it will give you more energy than sitting.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AlreadyRegisteredErrorMsg;
